/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

export type AppSagasLoadDataQueryVariables = {};
export type AppSagasLoadDataQueryResponse = {
    readonly stationList: {
        readonly stations: ReadonlyArray<{
            readonly stationId: string | null;
            readonly city: string | null;
            readonly country: {
                readonly countryId: string;
                readonly name: string | null;
                readonly sign: string | null;
            } | null;
            readonly disponame: string | null;
            readonly email: string | null;
            readonly fax: string | null;
            readonly isForeignStation: boolean | null;
            readonly isOneWayStation: boolean | null;
            readonly isRentStation: boolean | null;
            readonly isSharingStation: boolean | null;
            readonly latitude: number | null;
            readonly longitude: number | null;
            readonly name: string | null;
            readonly openingdate: string | null;
            readonly opentime: ReadonlyArray<{
                readonly breakEndtime: string | null;
                readonly breakStarttime: string | null;
                readonly endtime: string | null;
                readonly opentimeId: string;
                readonly starttime: string | null;
                readonly station: string | null;
                readonly weekDay: string | null;
            } | null> | null;
            readonly phonenumber: string | null;
            readonly street: string | null;
            readonly zipcode: string | null;
            readonly autoGenerateVehicleId: boolean | null;
        } | null> | null;
    } | null;
    readonly categoryList: {
        readonly categories: ReadonlyArray<{
            readonly categoryId: string;
            readonly sort: number | null;
            readonly enabledVehicleGroups: ReadonlyArray<{
                readonly vehicleGroupId: string;
            } | null> | null;
        } | null> | null;
    } | null;
    readonly equipmentList: {
        readonly equipments: ReadonlyArray<{
            readonly equipmentId: string;
            readonly description: string | null;
            readonly showInDispo: boolean | null;
        } | null> | null;
    } | null;
    readonly legendList: {
        readonly legends: ReadonlyArray<{
            readonly code: string | null;
            readonly color: string | null;
            readonly description: string | null;
            readonly legendCrw: boolean | null;
            readonly legendShorttext: string | null;
            readonly legendGroup: string | null;
        } | null> | null;
    } | null;
    readonly regionList: {
        readonly regions: ReadonlyArray<{
            readonly region: string | null;
            readonly enabledStations: ReadonlyArray<{
                readonly stationId: string | null;
            } | null> | null;
        } | null> | null;
    } | null;
    readonly vehicleGroupList: {
        readonly vehicleGroups: ReadonlyArray<{
            readonly vehicleGroupId: string;
            readonly category: string | null;
            readonly categoryText: string | null;
            readonly description: string | null;
            readonly descriptionWeb: string | null;
            readonly isEnabledForInternetUsage: boolean | null;
            readonly sort: number | null;
            readonly textWeb: string | null;
        } | null> | null;
    } | null;
    readonly paymentMethodList: {
        readonly paymentMethods: ReadonlyArray<{
            readonly allowedInContract: boolean | null;
            readonly allowedInInvoice: boolean | null;
            readonly alwaysAllowed: boolean | null;
            readonly descriptionOrm: string | null;
            readonly invoiceNotAllowed: boolean | null;
            readonly invoiceText: string | null;
            readonly invoiceTextCredit: string | null;
            readonly isEnabledForInternet: boolean | null;
            readonly name: string | null;
            readonly paymentMethodId: string;
            readonly paymentProviderCode: string | null;
            readonly prepaymentCheck: boolean | null;
            readonly printAccount: boolean | null;
            readonly standardAccount: number | null;
        } | null> | null;
    } | null;
    readonly countryList: {
        readonly countries: ReadonlyArray<{
            readonly countryId: string;
            readonly sign: string | null;
            readonly active: boolean | null;
        } | null> | null;
    } | null;
    readonly documentTypeList: {
        readonly documentType: ReadonlyArray<{
            readonly description: string | null;
        } | null> | null;
    } | null;
    readonly pricelistList: {
        readonly pricelists: ReadonlyArray<{
            readonly name: string;
            readonly dontShowInSelection: boolean | null;
        } | null> | null;
    } | null;
    readonly parameterList: {
        readonly parameters: ReadonlyArray<{
            readonly parameterId: string;
            readonly parameter: string;
            readonly description: string | null;
            readonly value: string | null;
        } | null> | null;
    } | null;
    readonly colorList: {
        readonly colors: ReadonlyArray<{
            readonly code: string | null;
            readonly color: string | null;
            readonly colorId: string;
            readonly description: string | null;
            readonly legendCrw: boolean | null;
            readonly legendGroup: string | null;
            readonly legendShorttext: string | null;
        } | null> | null;
    } | null;
    readonly userQueryList: {
        readonly queries: ReadonlyArray<{
            readonly queryId: number;
            readonly description: string | null;
            readonly parameters: ReadonlyArray<{
                readonly name: string | null;
                readonly type: string | null;
                readonly label: string | null;
            } | null> | null;
            readonly category: string | null;
        } | null> | null;
    } | null;
    readonly queryList: {
        readonly queries: ReadonlyArray<{
            readonly queryId: number;
            readonly description: string | null;
            readonly category: string | null;
        } | null> | null;
    } | null;
    readonly rightList: {
        readonly rights: ReadonlyArray<{
            readonly rightId: number | null;
            readonly right: string | null;
            readonly description: string | null;
        } | null> | null;
    } | null;
    readonly damageStateList: {
        readonly damageStates: ReadonlyArray<{
            readonly damageStateId: number;
            readonly state: string | null;
        } | null> | null;
    } | null;
    readonly taxKeyList: {
        readonly taxKeys: ReadonlyArray<{
            readonly taxKeyId: number;
            readonly taxKey: number | null;
            readonly percentage: number | null;
            readonly validFrom: string | null;
        } | null> | null;
    } | null;
    readonly mandant: {
        readonly mandantId: string;
        readonly logo: string | null;
        readonly abasId: number;
        readonly jasperHeader: string | null;
        readonly jasperFooter: string | null;
        readonly ownercode: string | null;
        readonly modules: ReadonlyArray<{
            readonly enabled: boolean;
            readonly name: string;
        } | null> | null;
        readonly openRemarkPopupInContract: boolean | null;
    } | null;
    readonly rateList: {
        readonly rates: ReadonlyArray<{
            readonly rate: string | null;
            readonly rateId: number | null;
            readonly description: string | null;
            readonly groupId: string | null;
            readonly mainRate: boolean | null;
        } | null> | null;
    } | null;
};
export type AppSagasLoadDataQuery = {
    readonly response: AppSagasLoadDataQueryResponse;
    readonly variables: AppSagasLoadDataQueryVariables;
};



/*
query AppSagasLoadDataQuery {
  stationList {
    stations {
      stationId
      city
      country {
        countryId
        name
        sign
      }
      disponame
      email
      fax
      isForeignStation
      isOneWayStation
      isRentStation
      isSharingStation
      latitude
      longitude
      name
      openingdate
      opentime {
        breakEndtime
        breakStarttime
        endtime
        opentimeId
        starttime
        station
        weekDay
      }
      phonenumber
      street
      zipcode
      autoGenerateVehicleId
    }
  }
  categoryList {
    categories {
      categoryId
      sort
      enabledVehicleGroups {
        vehicleGroupId
      }
    }
  }
  equipmentList {
    equipments {
      equipmentId
      description
      showInDispo
    }
  }
  legendList {
    legends {
      code
      color
      description
      legendCrw
      legendShorttext
      legendGroup
    }
  }
  regionList {
    regions {
      region
      enabledStations {
        stationId
      }
    }
  }
  vehicleGroupList {
    vehicleGroups {
      vehicleGroupId
      category
      categoryText
      description
      descriptionWeb
      isEnabledForInternetUsage
      sort
      textWeb
    }
  }
  paymentMethodList {
    paymentMethods {
      allowedInContract
      allowedInInvoice
      alwaysAllowed
      descriptionOrm
      invoiceNotAllowed
      invoiceText
      invoiceTextCredit
      isEnabledForInternet
      name
      paymentMethodId
      paymentProviderCode
      prepaymentCheck
      printAccount
      standardAccount
    }
  }
  countryList {
    countries {
      countryId
      sign
      active
    }
  }
  documentTypeList {
    documentType {
      description
    }
  }
  pricelistList {
    pricelists {
      name
      dontShowInSelection
    }
  }
  parameterList {
    parameters {
      parameterId
      parameter
      description
      value
    }
  }
  colorList {
    colors {
      code
      color
      colorId
      description
      legendCrw
      legendGroup
      legendShorttext
    }
  }
  userQueryList {
    queries {
      queryId
      description
      parameters {
        name
        type
        label
      }
      category
    }
  }
  queryList {
    queries {
      queryId
      description
      category
    }
  }
  rightList {
    rights {
      rightId
      right
      description
    }
  }
  damageStateList {
    damageStates {
      damageStateId
      state
    }
  }
  taxKeyList {
    taxKeys {
      taxKeyId
      taxKey
      percentage
      validFrom
    }
  }
  mandant {
    mandantId
    logo
    abasId
    jasperHeader
    jasperFooter
    ownercode
    modules {
      enabled
      name
    }
    openRemarkPopupInContract
  }
  rateList {
    rates {
      rate
      rateId
      description
      groupId
      mainRate
    }
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "stationId",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "countryId",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "sign",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "sort",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "vehicleGroupId",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "description",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "code",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "color",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "legendCrw",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "legendShorttext",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "legendGroup",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "category",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "queryId",
  "storageKey": null
},
v14 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "StationList",
    "kind": "LinkedField",
    "name": "stationList",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Station",
        "kind": "LinkedField",
        "name": "stations",
        "plural": true,
        "selections": [
          (v0/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "city",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Country",
            "kind": "LinkedField",
            "name": "country",
            "plural": false,
            "selections": [
              (v1/*: any*/),
              (v2/*: any*/),
              (v3/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "disponame",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "email",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "fax",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isForeignStation",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isOneWayStation",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isRentStation",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isSharingStation",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "latitude",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "longitude",
            "storageKey": null
          },
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "openingdate",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Opentime",
            "kind": "LinkedField",
            "name": "opentime",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "breakEndtime",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "breakStarttime",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "endtime",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "opentimeId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "starttime",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "station",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "weekDay",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "phonenumber",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "street",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "zipcode",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "autoGenerateVehicleId",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "CategoryList",
    "kind": "LinkedField",
    "name": "categoryList",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Category",
        "kind": "LinkedField",
        "name": "categories",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "categoryId",
            "storageKey": null
          },
          (v4/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "VehicleGroup",
            "kind": "LinkedField",
            "name": "enabledVehicleGroups",
            "plural": true,
            "selections": [
              (v5/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "EquipmentList",
    "kind": "LinkedField",
    "name": "equipmentList",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Equipment",
        "kind": "LinkedField",
        "name": "equipments",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "equipmentId",
            "storageKey": null
          },
          (v6/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "showInDispo",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "LegendList",
    "kind": "LinkedField",
    "name": "legendList",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Legend",
        "kind": "LinkedField",
        "name": "legends",
        "plural": true,
        "selections": [
          (v7/*: any*/),
          (v8/*: any*/),
          (v6/*: any*/),
          (v9/*: any*/),
          (v10/*: any*/),
          (v11/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "RegionList",
    "kind": "LinkedField",
    "name": "regionList",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Region",
        "kind": "LinkedField",
        "name": "regions",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "region",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Station",
            "kind": "LinkedField",
            "name": "enabledStations",
            "plural": true,
            "selections": [
              (v0/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "VehicleGroupList",
    "kind": "LinkedField",
    "name": "vehicleGroupList",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "VehicleGroup",
        "kind": "LinkedField",
        "name": "vehicleGroups",
        "plural": true,
        "selections": [
          (v5/*: any*/),
          (v12/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "categoryText",
            "storageKey": null
          },
          (v6/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "descriptionWeb",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isEnabledForInternetUsage",
            "storageKey": null
          },
          (v4/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "textWeb",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "PaymentMethodList",
    "kind": "LinkedField",
    "name": "paymentMethodList",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "PaymentMethod",
        "kind": "LinkedField",
        "name": "paymentMethods",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "allowedInContract",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "allowedInInvoice",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "alwaysAllowed",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "descriptionOrm",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "invoiceNotAllowed",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "invoiceText",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "invoiceTextCredit",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isEnabledForInternet",
            "storageKey": null
          },
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "paymentMethodId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "paymentProviderCode",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "prepaymentCheck",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "printAccount",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "standardAccount",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "CountryList",
    "kind": "LinkedField",
    "name": "countryList",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Country",
        "kind": "LinkedField",
        "name": "countries",
        "plural": true,
        "selections": [
          (v1/*: any*/),
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "active",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "DocumentTypeList",
    "kind": "LinkedField",
    "name": "documentTypeList",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "DocumentType",
        "kind": "LinkedField",
        "name": "documentType",
        "plural": true,
        "selections": [
          (v6/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "PricelistList",
    "kind": "LinkedField",
    "name": "pricelistList",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Pricelist",
        "kind": "LinkedField",
        "name": "pricelists",
        "plural": true,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "dontShowInSelection",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "ParameterList",
    "kind": "LinkedField",
    "name": "parameterList",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Parameter",
        "kind": "LinkedField",
        "name": "parameters",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "parameterId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "parameter",
            "storageKey": null
          },
          (v6/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "value",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "ColorList",
    "kind": "LinkedField",
    "name": "colorList",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Color",
        "kind": "LinkedField",
        "name": "colors",
        "plural": true,
        "selections": [
          (v7/*: any*/),
          (v8/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "colorId",
            "storageKey": null
          },
          (v6/*: any*/),
          (v9/*: any*/),
          (v11/*: any*/),
          (v10/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "UserDBQueryList",
    "kind": "LinkedField",
    "name": "userQueryList",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "DBQuery",
        "kind": "LinkedField",
        "name": "queries",
        "plural": true,
        "selections": [
          (v13/*: any*/),
          (v6/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "DBQueryParameter",
            "kind": "LinkedField",
            "name": "parameters",
            "plural": true,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "type",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "label",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v12/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "UserDBQueryList",
    "kind": "LinkedField",
    "name": "queryList",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "DBQuery",
        "kind": "LinkedField",
        "name": "queries",
        "plural": true,
        "selections": [
          (v13/*: any*/),
          (v6/*: any*/),
          (v12/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "RightList",
    "kind": "LinkedField",
    "name": "rightList",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Right",
        "kind": "LinkedField",
        "name": "rights",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "rightId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "right",
            "storageKey": null
          },
          (v6/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "DamageStateList",
    "kind": "LinkedField",
    "name": "damageStateList",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "DamageState",
        "kind": "LinkedField",
        "name": "damageStates",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "damageStateId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "state",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "TaxKeyList",
    "kind": "LinkedField",
    "name": "taxKeyList",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "TaxKey",
        "kind": "LinkedField",
        "name": "taxKeys",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "taxKeyId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "taxKey",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "percentage",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "validFrom",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "Mandant",
    "kind": "LinkedField",
    "name": "mandant",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "mandantId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "logo",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "abasId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "jasperHeader",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "jasperFooter",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "ownercode",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Module",
        "kind": "LinkedField",
        "name": "modules",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "enabled",
            "storageKey": null
          },
          (v2/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "openRemarkPopupInContract",
        "storageKey": null
      }
    ],
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "RateList",
    "kind": "LinkedField",
    "name": "rateList",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Rate",
        "kind": "LinkedField",
        "name": "rates",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "rate",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "rateId",
            "storageKey": null
          },
          (v6/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "groupId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "mainRate",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "AppSagasLoadDataQuery",
    "selections": (v14/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "AppSagasLoadDataQuery",
    "selections": (v14/*: any*/)
  },
  "params": {
    "cacheID": "5bfe76b6f58dc7bdb557aa54249dce89",
    "id": null,
    "metadata": {},
    "name": "AppSagasLoadDataQuery",
    "operationKind": "query",
    "text": "query AppSagasLoadDataQuery {\n  stationList {\n    stations {\n      stationId\n      city\n      country {\n        countryId\n        name\n        sign\n      }\n      disponame\n      email\n      fax\n      isForeignStation\n      isOneWayStation\n      isRentStation\n      isSharingStation\n      latitude\n      longitude\n      name\n      openingdate\n      opentime {\n        breakEndtime\n        breakStarttime\n        endtime\n        opentimeId\n        starttime\n        station\n        weekDay\n      }\n      phonenumber\n      street\n      zipcode\n      autoGenerateVehicleId\n    }\n  }\n  categoryList {\n    categories {\n      categoryId\n      sort\n      enabledVehicleGroups {\n        vehicleGroupId\n      }\n    }\n  }\n  equipmentList {\n    equipments {\n      equipmentId\n      description\n      showInDispo\n    }\n  }\n  legendList {\n    legends {\n      code\n      color\n      description\n      legendCrw\n      legendShorttext\n      legendGroup\n    }\n  }\n  regionList {\n    regions {\n      region\n      enabledStations {\n        stationId\n      }\n    }\n  }\n  vehicleGroupList {\n    vehicleGroups {\n      vehicleGroupId\n      category\n      categoryText\n      description\n      descriptionWeb\n      isEnabledForInternetUsage\n      sort\n      textWeb\n    }\n  }\n  paymentMethodList {\n    paymentMethods {\n      allowedInContract\n      allowedInInvoice\n      alwaysAllowed\n      descriptionOrm\n      invoiceNotAllowed\n      invoiceText\n      invoiceTextCredit\n      isEnabledForInternet\n      name\n      paymentMethodId\n      paymentProviderCode\n      prepaymentCheck\n      printAccount\n      standardAccount\n    }\n  }\n  countryList {\n    countries {\n      countryId\n      sign\n      active\n    }\n  }\n  documentTypeList {\n    documentType {\n      description\n    }\n  }\n  pricelistList {\n    pricelists {\n      name\n      dontShowInSelection\n    }\n  }\n  parameterList {\n    parameters {\n      parameterId\n      parameter\n      description\n      value\n    }\n  }\n  colorList {\n    colors {\n      code\n      color\n      colorId\n      description\n      legendCrw\n      legendGroup\n      legendShorttext\n    }\n  }\n  userQueryList {\n    queries {\n      queryId\n      description\n      parameters {\n        name\n        type\n        label\n      }\n      category\n    }\n  }\n  queryList {\n    queries {\n      queryId\n      description\n      category\n    }\n  }\n  rightList {\n    rights {\n      rightId\n      right\n      description\n    }\n  }\n  damageStateList {\n    damageStates {\n      damageStateId\n      state\n    }\n  }\n  taxKeyList {\n    taxKeys {\n      taxKeyId\n      taxKey\n      percentage\n      validFrom\n    }\n  }\n  mandant {\n    mandantId\n    logo\n    abasId\n    jasperHeader\n    jasperFooter\n    ownercode\n    modules {\n      enabled\n      name\n    }\n    openRemarkPopupInContract\n  }\n  rateList {\n    rates {\n      rate\n      rateId\n      description\n      groupId\n      mainRate\n    }\n  }\n}\n"
  }
};
})();
(node as any).hash = 'c483c9d8b9c47c68496d93b978f55a60';
export default node;
